export default __webpack_public_path__ + "static/extrawax-69527dcaf99134e18081e7be85d9b2ae.png";